import { Navigate } from 'react-router';
import TeamFarmsView from '../views/TeamFarmsView';
import PageLayout from '../layouts/PageLayout';
import TeamLayout from '../layouts/TeamLayout';
import TeamBreadcrumbLayout from '../layouts/TeamBreadcrumbLayout';
import {
  TeamCapexesView,
  TeamCropTemplatesView,
  TeamInputsView,
} from '../views/TeamResourcesView';
import { EditTemplateCropSettings } from '../components/templates/EditCropSettings';
import { cropTabRoutes, TemplateCropTabLayout } from '../layouts/CropTabLayout';
import { EditCapexResource } from '../components/templates/EditCapex';
import { EditInputResource } from '../components/templates/EditInput';
import { EditFuelPricingResource } from '../components/templates/EditFuel';
import TeamMembersView from '../views/TeamMembersView';
import AddTeamMember from '../components/team/AddTeamMember';
import NewTeamFarm from '../components/farm/NewTeamFarm';
import TeamSettingsView from '../views/TeamSettingsView';
import InviteMembers from '../components/onboarding/InviteMembers';
import OnboardingFlow from '../components/onboarding/OnboardingFlow';
import BillingPortal from '../components/BillingPortal';

const TeamRoutes = {
  path: 'team/:teamId',
  element: <TeamLayout />,
  children: [
    // Ensure that '/app/team' redirects to team home
    { index: true, element: <Navigate to="farms" replace /> },
    {
      element: <TeamLayout action="canUpdateSettings" />,
      children: [
        {
          path: 'onboard',
          children: [
            { index: true, element: <OnboardingFlow /> },
            { path: 'invite', element: <InviteMembers /> },
          ],
        },
        { path: 'billing', element: <BillingPortal /> },
      ],
    },
    {
      element: <PageLayout />,
      children: [
        { path: 'farms', element: <TeamFarmsView /> },
        {
          element: <TeamBreadcrumbLayout />,
          children: [
            // All team members can view this page
            { path: 'members', element: <TeamMembersView /> },
            {
              element: <TeamLayout action="canEdit" />,
              children: [
                { path: 'farms/new', element: <NewTeamFarm /> },
                {
                  path: 'templates',
                  children: [
                    { index: true, element: <TeamCropTemplatesView /> },
                    { path: 'new', element: <EditTemplateCropSettings /> },
                    {
                      path: ':id',
                      element: <TemplateCropTabLayout />,
                      children: cropTabRoutes({
                        componentAccessor: 'templateComponent',
                        IndexComponent: EditTemplateCropSettings,
                      }),
                    },
                  ],
                },
                {
                  path: 'capexes',
                  children: [
                    { index: true, element: <TeamCapexesView /> },
                    { path: 'new', element: <EditCapexResource /> },
                    { path: ':id/edit', element: <EditCapexResource /> },
                  ],
                },
                {
                  path: 'inputs',
                  children: [
                    { index: true, element: <TeamInputsView /> },
                    { path: 'new', element: <EditInputResource /> },
                    { path: ':id/edit', element: <EditInputResource /> },
                    {
                      path: 'pricing/new',
                      element: <EditFuelPricingResource />,
                    },
                    {
                      path: 'pricing/:id/edit',
                      element: <EditFuelPricingResource />,
                    },
                  ],
                },
              ],
            },
            {
              element: <TeamLayout action="canUpdateMembers" />,
              children: [{ path: 'members/new', element: <AddTeamMember /> }],
            },
            {
              element: <TeamLayout action="canUpdateSettings" />,
              children: [{ path: 'settings', element: <TeamSettingsView /> }],
            },
          ],
        },
      ],
    },
  ],
};

export default TeamRoutes;
